export default __webpack_public_path__ + "static/media/lalamove_motorcycle.e6add0ea.png";